export default __webpack_public_path__ + "static/tag-do-2-light-64fb5b67235a113c809b5d6b9080b94b.png";